import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PlansPage, { S } from "./PlansPage";
import LicensePage from "./users";
import License from "./License";
import AccountsPage from "./AccountsPage";
import GetCompanyInfoService from "../../services/company/getCompanyInfoService";

const TABS = [
  { key: "accounts", label: "Accounts", icon: "fa-solid fa-users" },
  { key: "license", label: "Manage License", icon: "fa-regular fa-id-badge" },
  { key: "users", label: "Manage Users", icon: "fa-regular fa-id-badge" },
  { key: "plans", label: "Plans", icon: "fa-regular fa-rectangle-list" },

];

function Subscription() {
  const [activeTab, setActiveTab] = useState("accounts");
  const [accountInfo, setAccountInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    GetCompanyInfoService.getCompanyInfo()
      .then((res) => {
        setAccountInfo({
          name: res.data.name,
          email: res.data.user_email,
          companyName: res.data.company_name,
        });
      })
      .catch(() => { });
  }, []);

  const initials = ((accountInfo && accountInfo.companyName) || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  return (
    <div className="container-fluid py-4" style={S.page}>
      <ToastContainer />

      <div style={S.container}>
        <div style={S.titleBlock}>
          <div>
            <h1 style={S.title}>Subscription</h1>
            <p style={S.subtitle}>Choose the plan that fits your business needs.</p>
          </div>
        </div>

        <div style={S.tabs}>
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              style={{
                ...S.tab,
                ...(activeTab === tab.key ? S.tabActive : {}),
              }}
              onClick={() => setActiveTab(tab.key)}
            >
              <i className={tab.icon} />
              {tab.label}
            </button>
          ))}
        </div>
          {activeTab === "accounts" && <AccountsPage />}
          {activeTab === "license" && <License />}
          {activeTab === "users" && <LicensePage />}
          {activeTab === "plans" && <PlansPage />}
      </div>
    </div>
  );
}

export default Subscription;
